/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect, useContext } from 'react';
import { Button } from 'src/common/Button';
import { config } from '@abyss/ui/tools/config';
import { storage } from '@abyss/ui/tools/storage';
import { DataTable } from '@abyss/ui/base/DataTable';
import { styled } from '@abyss/ui/tools/styled';
import { AlertContext } from 'src/tools/AlertContext';
import { useAdminContext } from 'src/hooks/useAdminContext';
import { useUserInfoStore } from 'src/store/useUserInfoStore';

import { FindForm } from './FindForm';

const ContinueButton = styled.div({
  margin: '20px 100px 20px 0',
  float: 'right',
});

const Heading = styled.h3({
  marginTop: 20,
});

const columns = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: data => {
      return (
        <div id={`provider-name-${data.row.index}`}>{data.cell.value}</div>
      );
    },
  },
  {
    Header: 'MPIN',
    accessor: 'mpin',
    Cell: data => {
      return (
        <div id={`provider-mpin-${data.row.index}`}>{data.cell.value}</div>
      );
    },
  },
  {
    Header: 'NPI',
    accessor: 'npi',
    Cell: data => {
      return <div id={`provider-npi-${data.row.index}`}>{data.cell.value}</div>;
    },
  },
];

export const IntakeUser = () => {
  const [selectedRow, setSelectedRow] = useState({});
  const [providers, setProviders] = useState([]);
  const { data: userInfo } = useUserInfoStore();
  const errorContext = useContext(AlertContext);
  const handleRowClick = rowData => {
    setSelectedRow(rowData || {});
  };

  const [, setAdminContext] = useAdminContext({
    onCompleted: () => {
      const redirect = storage.session.get('redirect');
      window.location = decodeURIComponent(redirect || config('SDE_URL'));
    },
    onError: error => {
      errorContext.addAlert(error);
    },
  });

  const handleContinue = () => {
    const provider = {
      taxIdNumber: selectedRow.tin,
      servicingProviderMpin: selectedRow.mpin,
      servicingProviderFirstName: selectedRow.firstName,
      servicingProviderLastName: selectedRow.lastName,
      phoneNumber: selectedRow.primaryPhoneNumber,
    };

    setAdminContext({
      variables: {
        role: 'referral-intake-user',
        id: userInfo?.uuid,
        username: userInfo?.username,
        provider,
      },
    });
  };

  useEffect(() => {
    if (providers.length === 0) {
      setSelectedRow({});
    }
  }, [providers.length]);

  return (
    <React.Fragment>
      <p data-testid="referral-intake-header">
        The ID you signed in with has Referral Intake User Access. Please enter
        the TIN of the referring provider and click submit search.
      </p>
      <FindForm clearRow={handleRowClick} setProviders={setProviders} />
      <If condition={providers.length > 0}>
        <Heading>Confirm Provider</Heading>
        <p>
          Click the name of the referred from provider. Then click continue.
        </p>
        <DataTable
          data={providers}
          columns={columns}
          showFilters
          getRowProps={row => {
            return {
              onClick: () => handleRowClick(row.original),
              style: {
                cursor: 'pointer',
                ...(row.values.mpin === selectedRow.mpin && {
                  background: '#0F880C',
                  color: '#FFF',
                }),
              },
            };
          }}
        />
      </If>
      <ContinueButton>
        <Button
          data-testid="continue-button"
          size="size700"
          isDisabled={!selectedRow.mpin}
          onClick={handleContinue}
        >
          Continue
        </Button>
      </ContinueButton>
    </React.Fragment>
  );
};
